import { RouteNamesEnum } from '@/enums/RouteNamesEnum';

const CalibrationsRoutes = [
    {
        path: '/calibrations',
        component: () => import('../components/general/RootModule.vue'),
        meta: {
            title: 'CalibrationsModule.module-name',
            icon: 'mdi-certificate-outline',
            auth: {
                required: true,
            },
            showInMenu: true,
            moduleRoot: true,
        },
        children: [
            {
                path: '',
                name: RouteNamesEnum.Calibrations,
                component: () => import('../views/calibrations-module/CalibrationsView.vue'),
                meta: {
                    title: 'CalibrationsModule.calibrations',
                    auth: {
                        required: true,
                    },
                    showInMenu: true,
                    isArchive: false,
                },
            },
        ],
    },
];

export default CalibrationsRoutes;
